module.exports = __webpack_public_path__ + "static/media/thumbnail.210195a3.jpg";